import { useEffect, useState } from 'react';

export const useResponsiveSliderSettings = () => {
    const breakpoints = [
        { minWidth: 1200, slidesPerView: 7, slidesPerGroup: 7 },
        { minWidth: 992, slidesPerView: 6, slidesPerGroup: 6 },
        { minWidth: 768, slidesPerView: 5, slidesPerGroup: 5 },
        { minWidth: 576, slidesPerView: 4, slidesPerGroup: 4 },
        { minWidth: 425, slidesPerView: 3, slidesPerGroup: 3 },
        { minWidth: 0, slidesPerView: 2, slidesPerGroup: 2 },
    ];

    const getConfig = () => {
        const width = window.innerWidth;

        const {
            slidesPerView,
            slidesPerGroup
        } = breakpoints.find(breakPoint => width >= breakPoint.minWidth);

        return { slidesPerView, slidesPerGroup };
    };

    const [config, setConfig] = useState(getConfig());

    useEffect(() => {
        const handleResize = () => setConfig(getConfig());
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return config;
};